//import  dependencies
import "../styles/output.css"
import '../styles/global.css'
//return Footer
let Footer=()=>{
    return(
        <div className="main px-2 mobile-m:px-9 flex flex-row justify-between bg-neutral-950">
            <div className="Footer-list">
                <h5 className="font-bold">Navigation</h5>
                <ul>
                    <li>Header</li>
                    <li>About</li>
                    <li>Works</li>
                    <li>Services</li>
                    <li>Skills</li>
                </ul>
            </div>
            <div className="Footer-list">
            <h5 className="font-bold">Contacts</h5>
                <ul>
                    <li>Email: <a href='mailto:soweroy@gmail.com'>soweroy@gmail.com</a></li>
                    <li>Phone: <a href='tel:+254768841833'>0768841833</a></li>
                    <li>Instagram: <a href='https://www.instagram.com/royderell.png?igsh=MWdocDR6YzNjMHBmcQ=='>royderell.png</a></li>
                    <li>WhatsApp: <a href='https://wa.me/254768841833'>0768841833</a></li>
                </ul>
            </div>
        </div>
    )
}
export default Footer